import {AnswerType} from './model/answer-type';
import {BooleanAnswerValue} from './model/boolean-answer-value';
import {TimeAnswerValue} from './model/time-answer-value';
import {ListAnswerValue} from './model/list-answer-value';
import {Answer} from './model/answer';
import {Pipe, PipeTransform} from '@angular/core';

export const BOOL_OPERATORS = ['equals'];
export const COMPARABLE_OPERATORS = ['greater',
  'less',
  'greater or equals',
  'less or equals',
  'equals'
];
export const ITERABLE_OPERATORS = ['any', 'each'];

export const YES_NO_ANSWER_TYPE_NAME = 'Y/N';
export const YES_NO_ANSWER_TYPE = new AnswerType(YES_NO_ANSWER_TYPE_NAME, BOOL_OPERATORS);
export const TIME_ANSWER_TYPE = 'time';
export const LIST_ANSWER_TYPE = 'list';

export const ANSWER_TYPES : AnswerType[] = [
  YES_NO_ANSWER_TYPE,
  new AnswerType(TIME_ANSWER_TYPE, COMPARABLE_OPERATORS),
  new AnswerType(LIST_ANSWER_TYPE, BOOL_OPERATORS)
];

export const RECOMMENDATION_SUPPORTED : AnswerType[] = [YES_NO_ANSWER_TYPE];

export const ANSWER_TYPE_NAMES = ANSWER_TYPES.map(t => t.type);

export const YES_LABEL = 'Yes';
export const NO_LABEL = 'No';

export const YES_TEMPLATE = new BooleanAnswerValue(YES_LABEL, false);
export const NO_TEMPLATE = new BooleanAnswerValue(NO_LABEL, false);
export const TIME_TEMPLATE = new TimeAnswerValue('', 'HH:mm');
export const LIST_TEMPLATE  = new ListAnswerValue('', false, '');

export const Y_N_ANSWER = new Answer(YES_NO_ANSWER_TYPE_NAME, [YES_TEMPLATE, NO_TEMPLATE]);
export const TIME_ANSWER = new Answer(TIME_ANSWER_TYPE, [TIME_TEMPLATE]);
export const LIST_ANSWER = new Answer(LIST_ANSWER_TYPE, []);

export const AVAILABLE_ANSWERS = [Y_N_ANSWER, TIME_ANSWER];

export const BY_ANSWER_EXPLANATION_TYPE = 'By answer';
export const TEXT_EXPLANATION_TYPE = 'Text';
export const AVAILABLE_EXPLANATION_TYPES = [TEXT_EXPLANATION_TYPE, BY_ANSWER_EXPLANATION_TYPE];

export const RECOMMENDATION_SUPPORTED_ANSWER_VALUES = [YES_TEMPLATE, NO_TEMPLATE];

export const RECOMMENDATION_TYPES = ['T1', 'T2-4'];

@Pipe({
  name: 'crop'
})
export class CropPipe implements PipeTransform {
  transform(value: string, limit: number, trail: string): string {
    return value.length > limit ? value.substring(0, limit) + trail : value;
  }

}

@Pipe({
  name: 'duration'
})
export class DurationPipe implements PipeTransform {
  transform(value: number): string {
    let millis: number = value % 1000;
    let seconds: number = ((value - millis) / 1000) % 60;
    let minutes: number = (((value - millis) / 1000 - seconds) / 60) % 60;
    let hours: number = (((value - millis) / 1000 - seconds) / 60 - minutes) / 60;
    //ceil up
    if (millis > 0) seconds +=1;
    if (seconds == 60) {
      seconds = 0;
      minutes +=1;
    }
    if (minutes == 60) {
      minutes = 0;
      hours += 1;
    }
    let secondsStr: string = (seconds < 10 ? "0" : "") + seconds;
    let minutesStr: string = (minutes < 10 ? "0" : "") + minutes;
    let hoursStr: string = (hours < 10 ? "0" : "") + hours;
    return hoursStr + ":" + minutesStr + ":" + secondsStr;
  }

}




// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/constants.ts